import {
  ScrollContainerBox,
  StyledFab,
  StyledKeyboardArrowUpIcon,
} from "./ScrollContainerWrapper.styles";
import { useDispatch, useSelector } from "react-redux";
import { headerActions } from "../../store/reducers/header";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { stripTrailingSlash } from "../../utils/config";

const ScrollContainerWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const strippedPathname = stripTrailingSlash(location.pathname);
  const isHeaderShrink = useSelector((state) => state.header.isHeaderShrink);
  const shrinkScrollTopVal = strippedPathname === `/web/connections/my-connections`?150:20;
  const scrollToTop = () => {
    document
      .getElementById("back-to-top-anchor")
      .scroll({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    dispatch(headerActions.setIsShrink(false));
  }, []);

  const scrollHeaderShrinkHandler = (event) => {
    if (event.target.scrollTop > shrinkScrollTopVal && isHeaderShrink === false) {
      dispatch(headerActions.setIsShrink(true));
    } else if (event.target.scrollTop < 20  && isHeaderShrink === true) {
      dispatch(headerActions.setIsShrink(false));
    }
  };

  return (
    <>
      <ScrollContainerBox
        onScroll={scrollHeaderShrinkHandler}
        isHeaderShrink={isHeaderShrink}
        id="back-to-top-anchor"
      >
        {children}
      </ScrollContainerBox>
      {isHeaderShrink && (
        <Box onClick={scrollToTop} role="presentation">
          <StyledFab size="small" aria-label="scroll back to top">
            <StyledKeyboardArrowUpIcon />
          </StyledFab>
        </Box>
      )}
    </>
  );
};

export default ScrollContainerWrapper;
